import { render, staticRenderFns } from "./Imersao.vue?vue&type=template&id=dafd7670&scoped=true"
import script from "./Imersao.vue?vue&type=script&lang=js"
export * from "./Imersao.vue?vue&type=script&lang=js"
import style0 from "./Imersao.vue?vue&type=style&index=0&id=dafd7670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafd7670",
  null
  
)

export default component.exports